// Timeout is set in sysconfig table on row 'idle_timeout_minutes'
// If 'idle_timeout_minutes' does not exist in sysconfig table, default is 15 minutes
// If 'idle_timeout_minutes' is set to 0, idle timer is disabled
// If 'idle_timeout_minutes' is set to any number , idle timeout is set to that number of minutes
const DEFAULT_TIMEOUT_MINUTES = 15;

export const WARNING_BEFORE = 1 * 60 * 1000;

const EVENTS = ['mousemove', 'keydown', 'mousedown', 'click', 'touchstart', 'scroll'];

export function createIdleTimer({ onWarn, onLogout, timeoutMinutes = DEFAULT_TIMEOUT_MINUTES, enabled = true }) {
  if (!enabled || !timeoutMinutes || timeoutMinutes <= 0) return { start() {}, stop() {}, reset() {} };

  const idleTimeout = timeoutMinutes * 60 * 1000;

  let warnTimer = null;
  let logoutTimer = null;

  function reset() {
    clearTimeout(warnTimer);
    clearTimeout(logoutTimer);
    warnTimer = setTimeout(onWarn, idleTimeout - WARNING_BEFORE);
    logoutTimer = setTimeout(onLogout, idleTimeout);
  }

  function start() {
    EVENTS.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
  }

  function stop() {
    clearTimeout(warnTimer);
    clearTimeout(logoutTimer);
    EVENTS.forEach(e => window.removeEventListener(e, reset));
  }

  return { start, stop, reset };
}
